<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../stores/shipMng.store";
    import { login_id } from "../stores/auth.store";
    import Header from "../components/Header.svelte";

    let barcodeInput_1;
    let barcodeInputValue_1 = "";
    let barcodeInput_2;
    let barcodeInputValue_2 = "";
    let scanTimeout;
    let interval;
    let isPaused = false;

    let getDate = new Date().toISOString().slice(0, 10); // 입고일자

    // 출하전표(거래명세서) 바코드 리딩
    let barcodeList = [];
    let shipmnt_no = "";
    let bcnc_nm = "";
    let shipmnt_de = "";

    let total_qy = 0; // 발주 수량 total
    let total_inpt_qy = 0; // 입고 수량 total

    // 발주정보조회 팝업창
    let detailList = [];

    function manageFocus() {
        if (isPaused) return;

        if (barcodeInputValue_1 === "") {
            barcodeInput_1.focus();
            barcodeInput_1.click();
        } else {
            barcodeInput_2.focus();
            barcodeInput_2.click();
        }
    }

    onMount(() => {
        interval = setInterval(manageFocus, 1000);

        apiGetShipMngDetail();
    });

    onDestroy(() => {
        clearInterval(interval);
        clearTimeout(scanTimeout);
    });

    function inputBarcode(event) {
        clearTimeout(scanTimeout); // 입력 발생 시 타임아웃 초기화

        scanTimeout = setTimeout(async function () {
            if (
                event.target.id === "barcode_1" ||
                barcodeInputValue_1.trim() === ""
            ) {
                if (barcodeInputValue_1.trim() !== "") {
                    // 거래명세서 바코드 리딩
                    const response =
                        await api.apiGetShipMng(barcodeInputValue_1);

                    if (response == "") {
                        barcodeInputValue_1 = "";
                        return;
                    }

                    shipmnt_no = barcodeInputValue_1;
                    bcnc_nm = response[0].bcnc_nm;
                    shipmnt_de = response[0].shipmnt_de;

                    barcodeList = [
                        ...response.map((item, index) => {
                            total_qy += item.qy;
                            total_inpt_qy += item.conf_qy;

                            return {
                                id: barcodeList.length + index + 1,
                                shipmnt_sn: item.shipmnt_sn,
                                item_code: item.item_code,
                                item_nm: item.item_nm,
                                qy: item.qy,
                                conf_qy: item.conf_qy,
                            };
                        }),
                    ];
                }
            } else {
                if (barcodeInputValue_2.trim() !== "") {
                    let item_code_cnt = 0;

                    barcodeList = barcodeList.map((item) => {
                        if (item.item_code == barcodeInputValue_2) {
                            item_code_cnt++;
                            total_inpt_qy++;

                            return {
                                ...item,
                                conf_qy: item.conf_qy + 1,
                            };
                        }
                        return item;
                    });

                    if (item_code_cnt == 0) {
                        alert("출하대상 품목이 아닙니다.");
                    }

                    barcodeInputValue_2 = "";
                }
            }
        }, 900);
    }

    function chk_on(id) {
        var del_num_tr = document.getElementById(id);
        var del_num = id.split("tr_")[1];
        var del_num_on = "chk_" + del_num;
        var del_num_chk = document.getElementById(del_num_on);

        if (del_num_tr.classList.contains("on")) {
            del_num_tr.classList.remove("on");
            del_num_chk.checked = false;
        } else {
            del_num_tr.classList.add("on");
            del_num_chk.checked = true;
        }
    }

    function deleteList() {
        let elements = document.querySelectorAll(".on");

        if (elements.length == 0) {
            alert("선택한 품목이 없습니다.");
            return;
        }

        // 각 요소를 반복하여 출력합니다.
        elements.forEach((element) => {
            let idToDelete = element.id.split("tr_")[1];

            barcodeList = barcodeList.map((item) => {
                if (item.id == idToDelete) {
                    total_inpt_qy -= item.conf_qy;

                    return {
                        ...item,
                        conf_qy: 0,
                    };
                }
                return item;
            });

            barcodeList = [...barcodeList];
        });

        // // 선택된 on 모두 삭제
        elements = document.querySelectorAll(".on");
        elements.forEach((element) => {
            element.classList.remove("on");
        });
    }

    function deleteAll() {
        barcodeInputValue_1 = "";
        barcodeInputValue_2 = "";
        shipmnt_no = "";
        bcnc_nm = "";
        shipmnt_de = "";
        total_qy = 0;
        total_inpt_qy = 0;
        barcodeList = [];
    }

    async function postShipMng() {
        if (barcodeList.length == 0) {
            alert("출하 전표를 먼저 스캔해주세요.");
            return;
        }

        if (!(await api.apiPostShipMng(shipmnt_no, barcodeList))) {
            return;
        }

        alert("출하 등록되었습니다.");

        deleteAll();
    }

    function pop() {
        document.querySelector(".background").className = "background show-use";
    }

    function pop_close() {
        document.querySelector(".background").className = "background";
    }

    async function apiGetShipMngDetail() {
        const response = await api.apiGetShipMngDetail();

        detailList = [
            ...response.map((item, index) => ({
                id: detailList.length + index + 1,
                shipmnt_no: item.shipmnt_no,
                shipmnt_de: item.shipmnt_de,
                bcnc_nm: item.bcnc_nm,
            })),
        ];
    }

    async function select_order(input_shipmnt_no) {
        if (
            barcodeInputValue_1 != "" &&
            !confirm("확인 클릭 시 품목이 초기화되며,\n출하번호가 수정됩니다.")
        ) {
            return;
        }

        barcodeInputValue_1 = input_shipmnt_no;

        const response = await api.apiGetShipMng(barcodeInputValue_1);

        if (response == "") {
            barcodeInputValue_1 = "";
            return;
        }

        shipmnt_no = barcodeInputValue_1;
        bcnc_nm = response[0].bcnc_nm;
        shipmnt_de = response[0].shipmnt_de;

        barcodeList = [
            ...response.map((item, index) => {
                total_qy += item.qy;
                total_inpt_qy += item.conf_qy;

                return {
                    id: barcodeList.length + index + 1,
                    shipmnt_sn: item.shipmnt_sn,
                    item_code: item.item_code,
                    item_nm: item.item_nm,
                    qy: item.qy,
                    conf_qy: item.conf_qy,
                };
            }),
        ];

        pop_close();
    }
</script>

<Header />

<div class="menu-title">
    <p class="info-title" style="text-align: center;">출 하 관 리</p>
</div>

<input
    placeholder="출하전표(거래명세서) 바코드"
    bind:this={barcodeInput_1}
    bind:value={barcodeInputValue_1}
    on:input={inputBarcode}
    id="barcode_1"
    type="text"
    inputmode="none"
    style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);"
/>

<input
    placeholder="품목 라벨 바코드"
    bind:this={barcodeInput_2}
    bind:value={barcodeInputValue_2}
    on:input={inputBarcode}
    id="barcode_2"
    type="text"
    inputmode="none"
    style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);"
/>

<!-- style="touch-action: manipulation;
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    white-space: nowrap;
    clip-path: inset(100%);" -->

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="main-wrap">
    <div class="top-info">
        <div class="top-info-wrap">
            <div class="top-info-in">
                <p class="top-info-l">출하일자</p>
                <p class="top-info-r">{shipmnt_de}</p>
                <p class="btn-in" on:click={pop}>조회</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">출하번호</p>
                <p class="top-info-r">{shipmnt_no}</p>
            </div>
            <div class="top-info-in">
                <p class="top-info-l">거래처명</p>
                <p class="top-info-r">{bcnc_nm}</p>
            </div>
        </div>
    </div>

    <div class="list-dtl-wrap scroll-custom">
        <table>
            <tbody>
                <tr>
                    <th class="chk-box">checkbox</th>
                    <th>순번</th>
                    <th>품명</th>
                    <th>출하수량</th>
                    <th>등록수량</th>
                </tr>

                {#each barcodeList as data}
                    <tr
                        id="tr_{data.id}"
                        on:click={() => chk_on("tr_" + data.id)}
                    >
                        <td class="chk-box"
                            ><input type="checkbox" id="chk_{data.id}" /></td
                        >
                        <td>{data.shipmnt_sn}</td>
                        <td>{data.item_nm}</td>
                        <td>{data.qy}</td>
                        <td>{data.conf_qy}</td>
                    </tr>
                {/each}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">총계</td>
                    <td>{total_qy}</td>
                    <td>{total_inpt_qy}</td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div class="btn-h-wrap">
        <p on:click={postShipMng}>출하등록</p>
        <p class="del-btn" on:click={deleteList}>선택삭제</p>
        <p
            class="del-btn"
            on:click={() => {
                deleteAll();
            }}
        >
            초기화
        </p>
    </div>

    <!-- 발주 정보 조회 팝업 -->
    <div class="background">
        <div class="window">
            <div class="popup">
                <div class="popup-hd">
                    <p>발주 정보 조회</p>
                    <img
                        alt=""
                        src="resource/img/ico_close.png"
                        class="popup-close"
                        on:click={pop_close}
                    />
                </div>

                <div class="list-dtl-wrap list-dtl-wrap-pop" id="pop">
                    <table style="border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <th>출하번호</th>
                                <th>출하일자</th>
                                <th>거래처명</th>
                            </tr>

                            {#each detailList as data}
                                <tr
                                    on:click={() => {
                                        select_order(data.shipmnt_no);
                                    }}
                                >
                                    <td>{data.shipmnt_no}</td>
                                    <td>{data.shipmnt_de}</td>
                                    <td>{data.bcnc_nm}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
